module.exports = __webpack_public_path__ + "img/5.2632f760.png";